import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FaPaperPlane } from 'react-icons/fa';
import { styles } from '../styles/stylesContactDesktop';
import gradient from '../assets/images/gradient-contact-card.svg';
import FormStatus from './FormStatus';
 // <-- IMPORTADO AQUI
import {
  colaboradoresOptions,
  servicosOptions,
  investimentoOptions,
  prazoOptions,
} from '../data/dataContactForm';

function ContactDesktop({
  formData,
  setFormData,
  setCaptchaToken,
  emailError,
  whatsappError,
  handleChange,
  handleSubmit,
  isFormValid,
  formStatus,
  setFormStatus, // <-- RECEBENDO AQUI
}) {
  return (
    <section id="contact" style={styles.container}>
      <div style={styles.cardOuterBorder}>
        <div style={styles.card}>
          <img src={gradient} alt="Gradient Background" style={styles.cardImage} />
          <div style={styles.cardBlur}></div>

          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.leftColumn}>
              <div style={styles.inputCard}>
                <div style={styles.titleWrapper}>
                  <h2 style={styles.title}>Contato</h2>
                  <div style={styles.titleBar}></div>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nome</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    placeholder="Seu nome"
                    style={styles.input}
                  />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>E-mail</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Seu melhor e-mail"
                    style={{
                      ...styles.input,
                      ...(emailError ? styles.inputError : {}),
                    }}
                  />
                  {emailError && <span style={styles.errorMessage}>{emailError}</span>}
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Empresa</label>
                  <input
                    type="text"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleChange}
                    placeholder="Nome da sua empresa"
                    style={styles.input}
                  />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>WhatsApp</label>
                  <input
                    type="text"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    placeholder="(00) 00000-0000"
                    style={{
                      ...styles.input,
                      ...(whatsappError ? styles.inputError : {}),
                    }}
                  />
                  {whatsappError && <span style={styles.errorMessage}>{whatsappError}</span>}
                </div>
              </div>

              <div style={styles.captchaWrapper}>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={(token) => setCaptchaToken(token)}
                  theme="dark"
                />
              </div>

              <button
                type="submit"
                style={{
                  ...styles.submitButton,
                  ...(isFormValid() ? styles.submitButtonEnabled : {}),
                }}
                disabled={!isFormValid()}
              >
                Enviar <FaPaperPlane style={styles.icon} />
              </button>

              {/* FORM STATUS AQUI */}
              

            </div>

            <div style={styles.rightColumn}>
              <div style={styles.inputCard}>
                <div style={styles.rightTitleBar}></div>

                <div style={styles.group}>
                  <label style={styles.label}>Número de colaboradores da sua empresa</label>
                  <div style={styles.options}>
                    {colaboradoresOptions.map((option) => (
                      <button
                        type="button"
                        key={option}
                        onClick={() => setFormData({ ...formData, colaboradores: option })}
                        style={{
                          ...styles.optionButton,
                          ...(formData.colaboradores === option && styles.optionButtonActive),
                        }}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>

                <div style={styles.group}>
                  <label style={styles.label}>Serviço(s) desejados</label>
                  <div style={styles.options}>
                    {servicosOptions.map((service) => (
                      <button
                        type="button"
                        key={service}
                        onClick={() => {
                          const isSelected = formData.servicos.includes(service);
                          setFormData({
                            ...formData,
                            servicos: isSelected
                              ? formData.servicos.filter((s) => s !== service)
                              : [...formData.servicos, service],
                          });
                        }}
                        style={{
                          ...styles.optionButton,
                          ...(formData.servicos.includes(service) && styles.optionButtonActive),
                        }}
                      >
                        {service}
                      </button>
                    ))}
                  </div>
                </div>

                <div style={styles.group}>
                  <label style={styles.label}>Valor que espera investir</label>
                  <div style={styles.options}>
                    {investimentoOptions.map((option) => (
                      <button
                        type="button"
                        key={option}
                        onClick={() =>
                          setFormData({ ...formData, valorInvestimento: option })
                        }
                        style={{
                          ...styles.optionButton,
                          ...(formData.valorInvestimento === option && styles.optionButtonActive),
                        }}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>

                <div style={styles.group}>
                  <label style={styles.label}>Prazo para o projeto</label>
                  <div style={styles.options}>
                    {prazoOptions.map((option) => (
                      <button
                        type="button"
                        key={option}
                        onClick={() => setFormData({ ...formData, prazo: option })}
                        style={{
                          ...styles.optionButton,
                          ...(formData.prazo === option && styles.optionButtonActive),
                        }}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <FormStatus
        ref={null}
        status={formStatus}
        onClose={() => setFormStatus('default')}
      />
    </section>
  );
}

export default ContactDesktop;
